import React, { useCallback } from 'react'

import { Decorators } from 'components/RichTextEditor/decorators/useDecorators'
import { IEditorRef } from 'components/RichTextEditor/Editor'

import FormattingToolbar from '../formattingToolbar/FormattingToolbar'
import MCEditorContext from '../MCEditorContext'

import DefaultToolbar from './DefaultToolbar'
import { ToolbarModes } from './toolbarInterfaces'
import { useIsVisible } from './useIsVisible'

export interface ToolbarSelectorProps {
  className?: string
  decorators: Decorators
  editorRef: React.RefObject<IEditorRef>
  wrapperRef: React.RefObject<HTMLDivElement>
  onInsert: (value: string, selectionOffset?: number, options?: { shouldFocus: boolean }) => void
  open: boolean
}

const Toolbar = ({
  className,
  decorators,
  editorRef,
  onInsert,
  open,
  wrapperRef,
}: ToolbarSelectorProps) => {
  const isInViewport = useIsVisible(wrapperRef)

  const context = React.useContext(MCEditorContext)
  const toolbarMode = context.toolbar?.mode

  const focusEditor = useCallback(() => void editorRef.current?.focus(), [editorRef])
  const blurEditor = useCallback(() => void editorRef.current?.blur(), [editorRef])

  if (toolbarMode === ToolbarModes.DISABLED) {
    return null
  }

  const isToolbarOpen = isInViewport && open

  const selection = window.getSelection()
  const isSelectionOnEditor = editorRef.current?.inputRef?.current?.contains(
    selection?.focusNode || null,
  )
  const isTelegramRichText = isSelectionOnEditor && selection?.type === 'Range'

  if (toolbarMode === ToolbarModes.RICHTEXT) {
    return (
      <FormattingToolbar
        open={isToolbarOpen}
        decorators={decorators}
        onInsert={onInsert}
        anchor={editorRef.current?.inputRef}
        focusEditor={focusEditor}
        blurEditor={blurEditor}
      />
    )
  }

  return (
    <DefaultToolbar
      className={className}
      open={isToolbarOpen}
      onInsert={onInsert}
      focusEditor={focusEditor}
      isTelegramRichText={isTelegramRichText}
      decorators={decorators}
    />
  )
}

export default Toolbar
